import AdminPanelSettings from '@mui/icons-material/AdminPanelSettings'
import { Box, Tooltip } from '@mui/material'
import { SUPER_USER_ONLY_COLOR } from '@/theme/usePixydocsTheme'

/**
 * A small icon in the superuser color that marks something only superusers
 * can see, with a "Superuser only" tooltip. Put it next to a label or title,
 * in place of writing "Superuser only" in the text.
 */
export default function SuperUserOnlyIcon() {
  return (
    <Tooltip title="Superuser only">
      <Box
        component="span"
        role="img"
        aria-label="Superuser only"
        sx={{
          display: 'inline-flex',
          verticalAlign: 'middle',
          color: SUPER_USER_ONLY_COLOR,
        }}
      >
        <AdminPanelSettings sx={{ fontSize: 16 }} />
      </Box>
    </Tooltip>
  )
}
